/**
 * AromaFit HUSH — Lightweight EN/IT translator
 *
 * Strategy: walk text nodes; for each one whose trimmed content matches
 * an EN key, replace with IT. Original text is stashed on the parent
 * element via data-orig-en so we can switch back.
 *
 * The button is injected into the header — no liquid edits needed.
 */
(function () {
  // ─── Dictionary EN → IT ────────────────────────────────────────────────
  var DICT = {
    // Header / Nav / Announce
    "Free US shipping over $75 · 30-day quiet guarantee": "Spedizione USA gratuita oltre $75 · Garanzia 30 giorni",
    "Home": "Home",
    "Shop HUSH": "Acquista HUSH",
    "Science": "Scienza",
    "Reviews": "Recensioni",
    "Get HUSH": "Compra HUSH",

    // Hero (Home)
    "HUSH · The Aromatherapy Diffuser": "HUSH · Il Diffusore Aromaterapico",
    "Low stock": "Scorte basse",
    "Low stock · 47 left": "Scorte basse · 47 rimasti",
    "Suppress your appetite.": "Sopprimi il tuo appetito.",
    "Lose the weight.": "Perdi peso.",
    "Without dieting.": "Senza dieta.",
    "Get HUSH — from $79 →": "Compra HUSH — da $79 →",
    "See the science": "Vedi la scienza",
    "92% less snacking": "92% meno snack",
    "−4.1 kg in 8 weeks": "−4.1 kg in 8 settimane",
    "Works in 7 min": "Effetto in 7 min",
    "−4.1 kg": "−4.1 kg",
    "Average loss · 8 weeks": "Perdita media · 8 settimane",
    "Internal cohort of 2,184 customers, no diet, no exercise plan.": "Studio interno su 2.184 clienti, senza dieta, senza piano di allenamento.",

    // Trust strip
    "92% less snacking after 7 days": "92% meno snack dopo 7 giorni",
    "−4.1 kg average loss in 8 weeks": "−4.1 kg di perdita media in 8 settimane",
    "Works in 7 minutes": "Effetto in 7 minuti",
    "12,000+ Americans daily": "12.000+ americani ogni giorno",
    "30-day refund — keep the device": "Rimborso 30 giorni — tieni il dispositivo",

    // Problem
    "Read this slowly": "Leggi con calma",
    "It's not your fault.": "Non è colpa tua.",
    "You're not weak.": "Non sei debole.",

    // Solution
    "Meet HUSH": "Ecco HUSH",
    "One device.": "Un dispositivo.",
    "Less appetite. Less weight.": "Meno appetito. Meno peso.",

    // How it works
    "How HUSH ends the loop": "Come HUSH spezza il loop",
    "Press once": "Premi una volta",
    "Breathe for 7 minutes": "Respira per 7 minuti",
    "Walk away": "Vai avanti",

    // Scents
    "The HUSH Collection": "La Collezione HUSH",
    "Three scents.": "Tre profumi.",
    "One job: less appetite.": "Un solo lavoro: meno appetito.",
    "Mint": "Menta",
    "Citrus": "Agrumi",
    "Spice": "Spezia",
    "Peppermint · Eucalyptus": "Menta piperita · Eucalipto",
    "White grapefruit · Bergamot · Lemon": "Pompelmo bianco · Bergamotto · Limone",
    "Cinnamon · Cold vanilla · Cardamom": "Cannella · Vaniglia fredda · Cardamomo",
    "Discovery Pack · $89": "Discovery Pack · $89",
    "Pick three scents.": "Scegli tre profumi.",
    "Mix them how you want.": "Mixali come vuoi.",
    "Build my Discovery Pack": "Crea il mio Discovery Pack",

    // Story
    "A reader's story": "La storia di una lettrice",

    // Science
    "The science HUSH is built on": "La scienza su cui è costruito HUSH",
    "Aroma suppresses appetite.": "L'aroma sopprime l'appetito.",
    "Three decades of research say so.": "Tre decenni di ricerca lo dimostrano.",
    "Further reading": "Approfondisci",

    // Reviews
    "12,000+ Americans · 2,184 reviews": "12.000+ americani · 2.184 recensioni",
    "12,000+ rituals · 2,184 reviews": "12.000+ rituali · 2.184 recensioni",
    "average rating": "valutazione media",
    "Verified buyer": "Acquirente verificato",
    "✓ Verified buyer": "✓ Acquirente verificato",
    "Show all 18 reviews": "Mostra tutte le 18 recensioni",
    "Show fewer reviews": "Mostra meno recensioni",

    // Pricing
    "Choose your bundle": "Scegli il tuo pacchetto",
    "One device. Less appetite.": "Un dispositivo. Meno appetito.",
    "Already own a HUSH? You can buy refills only on the product page.": "Hai già un HUSH? Puoi comprare solo le ricariche dalla pagina prodotto.",
    "Starter": "Starter",
    "Discovery": "Discovery",
    "Ritual": "Ritual",
    "Most Loved": "Più amato",
    "HUSH Diffuser": "Diffusore HUSH",
    "Lasts ~15-30 days": "Dura ~15-30 giorni",
    "Lasts ~45-90 days": "Dura ~45-90 giorni",
    "Lasts ~90-180 days": "Dura ~90-180 giorni",

    // Guarantee
    "The 30-day \"keep it\" guarantee": "La garanzia \"tienitelo\" 30 giorni",
    "Try HUSH for 30 days.": "Prova HUSH per 30 giorni.",
    "Don't love it? Keep it. We'll refund you anyway.": "Non ti convince? Tienitelo. Ti rimborsiamo lo stesso.",

    // FAQ
    "Questions, answered straight": "Domande, risposte dirette",
    "FAQ": "Domande frequenti",
    "What does HUSH actually do?": "Cosa fa esattamente HUSH?",
    "Will I really lose weight with HUSH?": "Perderò davvero peso con HUSH?",
    "How long does one capsule last?": "Quanto dura una capsula?",
    "How long does a single capsule last?": "Quanto dura una singola capsula?",
    "Can I mix scents in the same bundle?": "Posso mixare i profumi nello stesso pacchetto?",
    "Can I mix and match scents in the same bundle?": "Posso mixare profumi diversi nello stesso pacchetto?",
    "I already own a HUSH. Can I just buy refills?": "Ho già un HUSH. Posso comprare solo le ricariche?",
    "I already own a HUSH. Can I just buy refill capsules?": "Ho già un HUSH. Posso comprare solo capsule di ricarica?",
    "Is it just a placebo?": "È solo un placebo?",
    "Is the appetite-suppression effect actually real, or is it placebo?": "L'effetto di soppressione dell'appetito è reale, o è placebo?",
    "Where do you ship?": "Dove spedite?",
    "What's the return policy?": "Qual è la politica di reso?",
    "Is it safe with kids and pets in the room?": "È sicuro con bambini e animali nella stanza?",
    "When during the day should I use HUSH?": "Quando durante il giorno dovrei usare HUSH?",
    "Which scent should I start with?": "Con quale profumo dovrei iniziare?",

    // Final CTA (Home)
    "Stop dieting. Start hushing.": "Basta diete. Inizia a fare HUSH.",
    "Free US shipping · 30-day refund (keep the device)": "Spedizione USA gratuita · Rimborso 30 giorni (tieni il dispositivo)",

    // Footer
    "Hush your hunger": "Zittisci la tua fame",
    "Shop": "Negozio",
    "About": "Su HUSH",
    "Stay in the loop": "Resta in contatto",
    "Wellness rituals, new scents, and quiet moments — once a month.": "Rituali wellness, nuovi profumi e momenti di calma — una volta al mese.",
    "Join": "Iscriviti",
    "HUSH Mint": "HUSH Menta",
    "HUSH Citrus": "HUSH Agrumi",
    "HUSH Spice": "HUSH Spezia",
    "Discovery Pack": "Discovery Pack",
    "Refills only": "Solo ricariche",
    "The Science": "La Scienza",
    "How It Works": "Come Funziona",
    "Privacy": "Privacy",
    "Terms": "Termini",
    "Shipping & Returns": "Spedizioni & Resi",

    // Product page — Buy box
    "Suppress appetite.": "Sopprimi l'appetito.",
    "Lose weight.": "Perdi peso.",
    "1. What are you buying?": "1. Cosa stai comprando?",
    "2. How many capsules?": "2. Quante capsule?",
    "3. Pick the scent for each capsule": "3. Scegli il profumo per ogni capsula",
    "Mix freely": "Mixa liberamente",
    "Starter Kit": "Kit Starter",
    "Diffuser + capsules": "Diffusore + capsule",
    "Already own a HUSH": "Hai già un HUSH",
    "Diffuser + 1 capsule": "Diffusore + 1 capsula",
    "Diffuser + 3 capsules": "Diffusore + 3 capsule",
    "Diffuser + 6 capsules": "Diffusore + 6 capsule",
    "1 capsule refill": "1 capsula di ricarica",
    "3 capsule refills": "3 capsule di ricarica",
    "6 capsule refills": "6 capsule di ricarica",
    "Single": "Singola",
    "Triple": "Triplo",
    "Stash": "Scorta",
    "Free US shipping · Ships in 1–2 business days · 30-day refund (keep the device)": "Spedizione USA gratuita · Spedito in 1–2 giorni · Rimborso 30 giorni (tieni il dispositivo)",
    "Free US shipping": "Spedizione gratuita",
    "30-day refund": "Rimborso 30 giorni",
    "Plant-derived": "Origine vegetale",
    "Cuts cravings 92%": "Taglia voglie 92%",
    "Clinically studied": "Clinicamente studiato",
    "Add to bag →": "Aggiungi al carrello →",

    // Product page — sections
    "Verified buyer · Los Angeles, CA": "Acquirente verificato · Los Angeles, CA",
    "What HUSH does": "Cosa fa HUSH",
    "The numbers": "I numeri",
    "we built HUSH around.": "su cui abbiamo costruito HUSH.",
    "less snacking after 7 days": "meno snack dopo 7 giorni",
    "less stress-eating between meals": "meno fame nervosa tra i pasti",
    "average loss in 8 weeks": "perdita media in 8 settimane",
    "Americans using HUSH daily": "americani usano HUSH ogni giorno",
    "Use it three times a day. Or once.": "Usalo tre volte al giorno. O una.",
    "It was built for three.": "È stato costruito per tre.",
    "Morning": "Mattina",
    "Afternoon": "Pomeriggio",
    "Evening": "Sera",
    "Kill the breakfast spiral": "Stoppa la spirale della colazione",
    "End the 3 PM sugar crash": "Spezza il calo zuccheri delle 15",
    "Stop the 9 PM kitchen raid": "Ferma l'incursione delle 21 in cucina",
    "How long does a capsule last?": "Quanto dura una capsula?",
    "Math, but": "Matematica,",
    "honest math.": "ma onesta.",
    "sessions per capsule": "sessioni per capsula",
    "per session, auto-off": "per sessione, spegnimento auto",
    "sessions per day, your call": "sessioni al giorno, decidi tu",
    "Once a day": "Una volta al giorno",
    "Twice a day": "Due volte al giorno",
    "Three times a day": "Tre volte al giorno",
    "30 days per capsule": "30 giorni per capsula",
    "15 days per capsule": "15 giorni per capsula",
    "10 days per capsule": "10 giorni per capsula",
    "Start your ritual →": "Inizia il tuo rituale →",
    "Important — please read": "Importante — leggi attentamente",
    "Side by side": "Confronto diretto",
    "Diets failed you.": "Le diete ti hanno deluso.",
    "HUSH ignores you.": "HUSH ti ignora.",
    "Diet apps": "App di dieta",
    "Supplements": "Integratori",
    "HUSH": "HUSH",
    "Daily willpower required": "Forza di volontà quotidiana richiesta",
    "Calorie counting": "Conta calorie",
    "Synthetic chemicals": "Sostanze chimiche sintetiche",
    "FTC-flagged claims": "Claim contestati dall'FTC",
    "Average abandonment in 2 weeks": "Abbandono medio in 2 settimane",
    "Plant-derived aromatic blend": "Blend aromatico di origine vegetale",
    "Just plug in. Press once.": "Basta inserire. Premere una volta.",
    "Works while you live your life": "Funziona mentre vivi la tua vita",
    "Switch to HUSH →": "Passa a HUSH →",
    "12,000 Americans.": "12.000 americani.",
    "Quieter kitchens.": "Cucine più silenziose.",
    "Inside a HUSH capsule": "Dentro una capsula HUSH",
    "What we put in.": "Cosa mettiamo dentro.",
    "And what we leave out.": "E cosa lasciamo fuori.",
    "What's in the box": "Cosa c'è nella scatola",
    "Open the box.": "Apri la scatola.",
    "Be in your first session in 90 seconds.": "Sei nella tua prima sessione in 90 secondi.",
    "Specs & details": "Specifiche & dettagli",
    "Designed to": "Progettato per",
    "disappear": "scomparire",
    "Dimensions": "Dimensioni",
    "Weight": "Peso",
    "Power": "Alimentazione",
    "Sound": "Suono",
    "Whisper-silent": "Silenzioso",
    "Session": "Sessione",
    "Capsule life": "Vita capsula",
    "30 sessions": "30 sessioni",
    "How HUSH actually works on your body": "Come HUSH funziona davvero sul tuo corpo",
    "Aroma in.": "Aroma dentro.",
    "Appetite out.": "Appetito fuori.",
    "A note from the founder": "Una nota dalla fondatrice",
    "Build your HUSH": "Crea il tuo HUSH",
    "Pick a bundle.": "Scegli un pacchetto.",
    "Start tonight.": "Inizia stasera.",
    "Starter Kit (with diffuser)": "Kit Starter (con diffusore)",
    "Pick the scent for each capsule": "Scegli il profumo per ogni capsula",
    "Selected": "Selezionato",
    "Select": "Seleziona",
    "In your own kitchen.": "Nella tua cucina.",
  };

  // ─── Reverse map ───────────────────────────────────────────────────────
  var REV_DICT = {};
  Object.keys(DICT).forEach(function (k) {
    REV_DICT[DICT[k]] = k;
  });

  // ─── Walk text nodes and translate ─────────────────────────────────────
  function getTextNodes(root) {
    var nodes = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        // Skip script/style and empty
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName;
        if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT") return NodeFilter.FILTER_REJECT;
        if (!n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function applyLang(lang) {
    var nodes = getTextNodes(document.body);
    nodes.forEach(function (n) {
      var t = n.nodeValue;
      var trimmed = t.trim();
      if (!trimmed) return;
      // Detect leading/trailing whitespace
      var lead = t.match(/^\s*/)[0];
      var tail = t.match(/\s*$/)[0];
      if (lang === "it") {
        if (DICT[trimmed]) {
          n.nodeValue = lead + DICT[trimmed] + tail;
        }
      } else {
        if (REV_DICT[trimmed]) {
          n.nodeValue = lead + REV_DICT[trimmed] + tail;
        }
      }
    });

    // Translate HTML attributes that show in UI
    document.querySelectorAll("input[placeholder]").forEach(function (el) {
      var ph = el.getAttribute("placeholder");
      var trimmed = ph && ph.trim();
      if (lang === "it" && DICT[trimmed]) el.setAttribute("placeholder", DICT[trimmed]);
      else if (lang === "en" && REV_DICT[trimmed]) el.setAttribute("placeholder", REV_DICT[trimmed]);
    });

    document.documentElement.lang = lang;
    try {
      localStorage.setItem("hush_lang", lang);
    } catch (e) {}
    updateSwitchState(lang);
  }

  // ─── Inject the EN | IT switch into the header ─────────────────────────
  function injectSwitch() {
    var headers = document.querySelectorAll("header.site-header .header-inner");
    headers.forEach(function (h) {
      if (h.querySelector(".lang-switch")) return; // already injected
      var sw = document.createElement("div");
      sw.className = "lang-switch";
      sw.innerHTML =
        '<button type="button" data-lang="en" aria-label="Switch to English">EN</button>' +
        '<span class="sep">|</span>' +
        '<button type="button" data-lang="it" aria-label="Cambia in italiano">IT</button>';
      // insert BEFORE the menu-toggle / nav-cta so it sits to the left
      var menuToggle = h.querySelector(".menu-toggle");
      var navCta = h.querySelector(".nav .nav-cta");
      if (menuToggle) {
        h.insertBefore(sw, menuToggle);
      } else {
        h.appendChild(sw);
      }

      sw.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          applyLang(b.dataset.lang);
        });
      });
    });

    // Also inject into mobile nav
    document.querySelectorAll("nav.nav-mobile").forEach(function (nm) {
      if (nm.querySelector(".lang-switch")) return;
      var sw = document.createElement("div");
      sw.className = "lang-switch lang-switch-mobile";
      sw.innerHTML =
        '<button type="button" data-lang="en">EN</button>' +
        '<span class="sep">|</span>' +
        '<button type="button" data-lang="it">IT</button>';
      nm.appendChild(sw);
      sw.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          applyLang(b.dataset.lang);
        });
      });
    });
  }

  function updateSwitchState(lang) {
    document.querySelectorAll(".lang-switch button").forEach(function (b) {
      if (b.dataset.lang === lang) b.classList.add("active");
      else b.classList.remove("active");
    });
  }

  // ─── Init ──────────────────────────────────────────────────────────────
  function init() {
    injectSwitch();
    var saved = "en";
    try {
      saved = localStorage.getItem("hush_lang") || "en";
    } catch (e) {}
    if (saved === "it") applyLang("it");
    else updateSwitchState("en");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
